export async function makeRequest(accessToken:string | null, url:string, method:string, data:any, selectedFile:any) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    headers.append("Authorization", bearer);
    if (data) headers.append('Content-Type', 'application/json');
    if (selectedFile) {
        const formData = new FormData();
        formData.append('file', selectedFile, selectedFile.name);
        return await fetch(url, {
            method:method,
            headers: headers,
            body: formData
        });
    }

    let options = {
        method: method,
        headers: headers,
        body: data ? JSON.stringify(data) : null,
    };

    const dotNetBasedResponse =  await fetch(url, options);
    return dotNetBasedResponse;
}
